import * as React from "react"

const Play = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 19 19" {...props}>
    <path d="M5.7 3.5a.4.4 0 0 0-.6.3v11.4c0 .3.4.4.6.3l8.5-5.7a.4.4 0 0 0 0-.6L5.7 3.5Z" />
  </svg>
)

export default Play
